export default "__VITE_ASSET__Du6nJT68__"